var map = {
	"./button.mp3": "cfd2",
	"./game-lose.mp3": "3879",
	"./hit.mp3": "6b50",
	"./impact.mp3": "50f7",
	"./success.mp3": "1ef2",
	"./sword.mp3": "5130",
	"./versus.mp3": "4558",
	"./victory.mp3": "066a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac03";